// extracted by mini-css-extract-plugin
export var dropdownContainer = "_61-5";
export var imageContainer = "_61-4";
export var metricsGrid = "_61-2";
export var productDetailContainer = "_61-1";
export var productListContainer = "_61-0";
export var subscriberTableContainer = "_61-3";